import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function useKeyboardShortcuts() {
  const navigate = useNavigate();

  useEffect(() => {
    function handler(e: KeyboardEvent) {
      // Don't trigger when typing in form elements
      const tag = (e.target as HTMLElement)?.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
      if ((e.target as HTMLElement)?.isContentEditable) return;

      // Cmd+K / Ctrl+K → dashboard (search placeholder)
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        navigate('/');
        return;
      }

      // Escape → dispatch custom close event
      if (e.key === 'Escape') {
        window.dispatchEvent(new CustomEvent('sasity:close-overlay'));
        return;
      }

      // Alt+key shortcuts
      if (!e.altKey) return;

      const routes: Record<string, string> = {
        b: '/trades/new',
        d: '/',
        p: '/portfolio',
        t: '/trades',
        n: '/notifications',
        s: '/config',
      };

      const route = routes[e.key.toLowerCase()];
      if (route) {
        e.preventDefault();
        navigate(route);
      }
    }

    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [navigate]);
}
